'use client'
import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const PortalContainerContext = /*#__PURE__*/ createContext(null);
function usePortalContainer() {
    return useContext(PortalContainerContext);
}
function PortalContainerProvider({ children, container }) {
    return /*#__PURE__*/ jsx(PortalContainerContext.Provider, {
        value: container ?? null,
        children: children
    });
}
export { PortalContainerProvider, usePortalContainer };
